module.exports = __webpack_public_path__ + "static/media/icn-email.f51d78dd.svg";